module.exports = __webpack_public_path__ + "static/media/logo.1b7c8e47.svg";